import {QTableColumn} from 'pansx-utils';

export class Notification {
    public id?: number;
    public userId = 0;
    public title = '';
    public message = '';
    public isRead?: boolean;
    public date?: Date;
    public qingAppName = '';
    public qingAppIocns = '';

    public static of(o: unknown): Notification {
        return Object.assign(new Notification(), o);
    }

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'id', field: 'id', label: '序号'},
            {name: 'userId', field: 'userId', label: '用户id'},
            {name: 'title', field: 'title', label: '标题'},
            {name: 'message', field: 'message', label: '消息'},
            {name: 'isRead', field: 'isRead', label: '已读取'},
        ];
    }

    public getColumnLabel(field: string) {
        const columns = Notification.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
